import type { Channel } from '~/types/Channel'

export function sortChannels(a: Channel, b: Channel) {
  return (a.app_order || 1000) - (b.app_order || 1000)
}
